"use client";

import { InfiniteMovingCards } from "@/components/ui/Card/InfiniteMovingCards";
import { FRIENDS } from "@/contants";
import { motion } from "framer-motion";

export default function Friend() {
  return (
    <div className="flex flex-col items-center">
      <motion.h1
        initial={{ opacity: 0, y: -100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2, ease: "easeInOut" }}
        viewport={{ once: true }}
        className="text-primary dark:text-[#45c3dc] text-3xl lg:text-4xl font-bold mt-4 text-center uppercase"
      >
        Huynh đệ
      </motion.h1>
      <motion.div
        initial={{ opacity: 0, y: -100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.4, ease: "easeInOut" }}
        viewport={{ once: true }}
        className="w-[20rem] h-2 bg-transparent relative mb-6 mt-2"
      >
        <div className="absolute inset-x-[40px] top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
        <div className="absolute inset-x-[40px] top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
        <div className="absolute inset-x-[120px] top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/4 blur-sm" />
        <div className="absolute inset-x-[120px] top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/4" />
      </motion.div>

      <InfiniteMovingCards
        className="lg:max-w-[80vw] mx-auto"
        items={FRIENDS}
        direction="right"
        speed="slow"
        type="friend"
      />
    </div>
  );
}
